"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var js_cookie_1 = __importDefault(require("js-cookie"));
var lodash_1 = require("lodash");
var cookieUtil = {
    set: function (name, value, options) {
        if (options === void 0) { options = {}; }
        var use_secure_cookie = window.location.protocol === 'https:';
        js_cookie_1["default"].set(name, (0, lodash_1.isString)(value) ? value : JSON.stringify(value), __assign({ secure: use_secure_cookie, path: '/', expires: 365 }, options));
        return this.get(name);
    },
    get: function (name) {
        var value = js_cookie_1["default"].get(name);
        try {
            return JSON.parse(value);
        }
        catch (e) {
            return value;
        }
    },
    remove: function (name, options) {
        if (options === void 0) { options = {}; }
        js_cookie_1["default"].remove(name, options);
    }
};
exports["default"] = cookieUtil;
